var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//region imports

import moment from 'moment';
import { DATEPICKER_FORMAT } from '../../../constants/data.constant';
import { CONNECT_SHOW_LAST_ALERTS_COUNT } from './alerts.constant';
import { tstToDate, flatArray } from '../../../utils/helpers';
import { mergeStateDateGroupedItems } from './alerts.algorithms';

// alerts icons
const iconWashMahine = require('../../../assets/images/icons/alerts/wash-machine.png');
const iconFridge = require('../../../assets/images/icons/alerts/fridge.png');
const iconStove = require('../../../assets/images/icons/alerts/stove.png');
const iconWaterHeater = require('../../../assets/images/icons/alerts/water-heater.png');
const iconLightning = require('../../../assets/images/icons/alerts/lightning.png');
const iconExclamation = require('../../../assets/images/icons/alerts/exclamation.png');
const iconCoins = require('../../../assets/images/icons/alerts/coins.png');
const iconError = require('../../../assets/images/icons/alerts/warning.png');

//endregion


export const processItems = items => {
    // items = filterItems(items, showErrors);
    let dateGroupedItems = groupItemsByDate(items);
    groupItemsByTitle(dateGroupedItems);

    return {
        // items,
        dateGroupedItems
    };
};

export const getMaxDate = (defaultDate, details) => {
    if (!details) {
        return defaultDate;
    }

    let dates = _getDatesFromDetails(details);
    dates = flatArray(flatArray(dates));

    if (dates.length) {
        const maxDateRaw = Math.max(...dates);
        const maxDate = tstToDate(maxDateRaw);
        return maxDate;
    }

    return defaultDate;
};

export const getMinDate = (defaultDate, details) => {
    if (!details) {
        return defaultDate;
    }

    let dates = _getDatesFromDetails(details);
    dates = flatArray(flatArray(dates));

    if (dates.length) {
        const minDateRaw = Math.min(...dates);
        const minDate = tstToDate(minDateRaw);
        return minDate;
    }

    return defaultDate;
};

const _getDatesFromDetails = details => {
    const { dateGroupedItems } = details;
    if (!dateGroupedItems || !dateGroupedItems.length) {
        return [];
    }

    const dates = dateGroupedItems.map(dateGroupedItem => {
        return dateGroupedItem.groupedItems.map(groupedItem => {
            return groupedItem.items.filter(item => {
                return item.severity.toLowerCase() !== "ERROR".toLowerCase();
            }).map(item => {
                return +item.dateRaw;
            });
        });
    });

    return dates;
};

export const getFirstNItemsFromDateGrouped = (dateGroupedItems, neededCount) => {
    const result = [];
    for (let j = 0; j < dateGroupedItems.length; j++) {
        const dateGroupedItem = dateGroupedItems[j];
        for (let i = 0; i < dateGroupedItem.groupedItems.length; i++) {
            const groupedItem = dateGroupedItem.groupedItems[i];
            for (let y = 0; y < groupedItem.items.length; y++) {
                result.push(groupedItem.items[y]);
                if (result.length === neededCount) {
                    return result;
                }
            }
        }
    }

    return result;
};

export const combineErrorsAndAlerts = (errors, alerts, lastItemsCount = 0) => {
    let dateGroupedItems = null;

    if (lastItemsCount) {
        const cutErrors = errors.items.slice(0, CONNECT_SHOW_LAST_ALERTS_COUNT);
        const cutAlerts = getFirstNItemsFromDateGrouped(alerts.dateGroupedItems, lastItemsCount);
        const groupedErrors = processItems(cutErrors);
        const groupedItems = processItems(cutAlerts);

        // dateGroupedItems = [
        //     ...groupedItems.dateGroupedItems,
        //     ...groupedErrors.dateGroupedItems,
        // ];
        dateGroupedItems = mergeStateDateGroupedItems(groupedItems.dateGroupedItems, cutErrors);
    } else {
        dateGroupedItems = mergeStateDateGroupedItems(alerts.dateGroupedItems, errors.items);
    }

    dateGroupedItems.sort(compareGroupedItemByDateDesc);
    return {
        details: _extends({}, alerts, {
            dateGroupedItems
        }),
        errors,
        alerts
    };
};

export const compareGroupedItemByTitle = (a, b) => {
    if (a.title < b.title) return -1;
    if (a.title > b.title) return 1;
    return 0;
};

export const compareGroupedItemByDateDesc = (a, b) => {
    const dateA = new moment(a.dateGroup, DATEPICKER_FORMAT).toDate();
    const dateB = new moment(b.dateGroup, DATEPICKER_FORMAT).toDate();
    return dateB - dateA;
};

export const compareAlerts = (a, b) => {
    if (+a.dateRaw > +b.dateRaw) return -1;
    if (+a.dateRaw < +b.dateRaw) return 1;

    return 0;
};

export const compareAlertsDesc = (a, b) => {
    if (+a.dateRaw < +b.dateRaw) return -1;
    if (+a.dateRaw > +b.dateRaw) return 1;

    return 0;
};

export const compareUnickAlerts = (a, b) => {
    const res = a.title + a.last === b.title + b.last;
    return res;
};

export const filterItems = (items, showErrors = false) => {
    if (showErrors) {
        return items.filter(i => i.isError);
    }

    return items.filter(i => !i.isError);
};

export const groupItemsByDate = items => {
    let dateGroupedItems = [];

    // 2 group by Date all alerts (per day)
    items.forEach((item, index) => {
        const dateIndex = dateGroupedItems.findIndex(r => r.dateGroup === item.dateGroup);
        if (!!~dateIndex) {
            const dateGroup = dateGroupedItems[dateIndex];
            dateGroup.items.push(item);
        } else {
            dateGroupedItems.push({
                dateGroup: item.dateGroup,
                items: [item]
            });
        }
    });

    dateGroupedItems.sort(compareGroupedItemByDateDesc);

    return dateGroupedItems;
};

export const groupItemsByTitle = dateGroupedItems => {
    const parseTitle = title => {
        if (!title) {
            return '';
        }
        const index = title.indexOf('--');
        if (index >= 0) {
            return title.substring(0, index - 1);
        }

        return title;
    };

    const convertToGroupedItem = item => {
        return {
            name: parseTitle(item.title),
            index: item.index,
            title: item.title,
            severity: item.severity,
            items: [item]
        };
    };

    // 3 group items inside date group (by Title)
    const NO_ELECTRICITY = 'no electricity'.toLowerCase();
    dateGroupedItems.forEach((dateGroupedItem, dateGroupedItemIndex) => {
        const groupedItems = [];
        dateGroupedItem.items.forEach((item, index) => {
            const title = parseTitle(item.title);

            // TODO Uros this is old variant when not see on ID in alert --123213123
            // const titleIndex = groupedItems.findIndex(r=> r.name === title);
            // this is when see on this ID
            const titleIndex = groupedItems.findIndex(r => r.title === item.title);

            if (titleIndex < 0) {
                groupedItems.push(convertToGroupedItem(item));
            } else {
                const group = groupedItems[titleIndex];
                group.items.push(item);
            }
        });

        // 4 filter grouped items for no Electricity
        groupedItems.forEach((item, index) => {
            let items = item.items;
            items.sort(compareAlertsDesc);

            // NO_ELECTRICITY custom message
            if (items.length === 2) {
                if (items[0].status === 'Open' && items[1].status === 'Resolved') {
                    if (items[0].title.toLower() == NO_ELECTRICITY && items[1].title.toLower() == NO_ELECTRICITY) {
                        const start = moment(items[0].date);
                        const end = moment(items[1].date);
                        const duration = moment.duration(end.diff(start));
                        item.summary = 'No electricity for ' + duration.humanize();
                    }
                }
            }

            item.items = items;
        });

        dateGroupedItem.groupedItems = groupedItems;
        // in selector used for get last top N items. Refactor this!!!
        delete dateGroupedItem.items;
    });

    return dateGroupedItems;
};

export const isImportantAlert = severity => {
    const result = !!~["WARNING".toLowerCase(), "ERROR".toLowerCase(), "CRITICAL".toLowerCase()].indexOf(severity.toLowerCase());

    return result;
};

export const findDateToScroll = (date, details) => {
    const { dateGroupedItems } = details;
    const selectedTime = date.getTime();

    for (let i = dateGroupedItems.length - 1; i >= 0; i--) {
        const dateGroupedItem = dateGroupedItems[i];
        const date = new moment(dateGroupedItem.dateGroup, DATEPICKER_FORMAT).toDate();
        if (date.getTime() >= selectedTime) {
            return dateGroupedItem;
        }
    }

    return null;
};

// TODO yura refactor this!
export const findAlertToScroll = (group, alert, index, details) => {
    const { dateGroupedItems } = details;
    for (let i = dateGroupedItems.length - 1; i >= 0; i--) {
        const dateGroupedItem = dateGroupedItems[i];
        if (dateGroupedItem.dateGroup === group.dateGroup) {
            const groupedItem = dateGroupedItem.groupedItems[index];
            return groupedItem;
        }
    }

    return null;
};

// TODO yura refactor this!
export const findAlertIndexToScroll = (group, unickIndex, details) => {
    const { dateGroupedItems } = details;
    for (let i = dateGroupedItems.length - 1; i >= 0; i--) {
        const dateGroupedItem = dateGroupedItems[i];
        if (dateGroupedItem.dateGroup === group.dateGroup) {
            const index = dateGroupedItem.groupedItems.findIndex(item => item.index === unickIndex);
            return {
                dateGroupedItem,
                index
            };
        }
    }

    return null;
};

// TODO bad detect icons!!!
export const getIcon = alert => {
    const parseIcon = title => {
        if (!title) return iconExclamation;
        if (!!~title.toLowerCase().indexOf('coins')) return iconCoins;
        if (!!~title.toLowerCase().indexOf('exclamation')) return iconExclamation;
        if (!!~title.toLowerCase().indexOf('fridge')) return iconFridge;
        if (!!~title.toLowerCase().indexOf('lightning')) return iconLightning;
        if (!!~title.toLowerCase().indexOf('stove')) return iconStove;
        if (!!~title.toLowerCase().indexOf('wash')) return iconWashMahine;
        if (!!~title.toLowerCase().indexOf('water')) return iconWaterHeater;
        return iconExclamation;
    };

    return parseIcon(alert.title);
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/core/alerts/alerts.helper.js